var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 222,
    viewBox: "0 0 224 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 0.5H223.3V221.9H0.799805V0.5Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.3 0.5H43.6997C40.386 0.5 37.6997 3.18629 37.6997 6.5V64.01C37.6997 67.3237 40.386 70.01 43.6997 70.01H209.3C212.613 70.01 215.3 67.3237 215.3 64.01V6.5C215.3 3.18629 212.613 0.5 209.3 0.5Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.3 152.4H43.6997C40.386 152.4 37.6997 155.087 37.6997 158.4V215.91C37.6997 219.224 40.386 221.91 43.6997 221.91H209.3C212.613 221.91 215.3 219.224 215.3 215.91V158.4C215.3 155.087 212.613 152.4 209.3 152.4Z",
    fill: "#C1C7D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8998 208.801H48.2998V210.801H91.8998V208.801Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 170.9H48.2998V172.9H163.4V170.9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.9 188.4H48.2998V190.4H111.9V188.4Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 179.4H48.2998V181.4H163.4V179.4Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 162.301H48.2998V164.301H163.4V162.301Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.9 184.4C198.803 184.4 204.4 178.804 204.4 171.9C204.4 164.997 198.803 159.4 191.9 159.4C184.996 159.4 179.4 164.997 179.4 171.9C179.4 178.804 184.996 184.4 191.9 184.4Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4 152.4H43.6997C42.1084 152.4 40.5823 153.033 39.4571 154.158C38.3318 155.283 37.6997 156.809 37.6997 158.4V164.3H152.1C158.776 168.082 166.327 170.047 174 170C180.887 170.001 187.682 168.413 193.856 165.361C200.031 162.308 205.418 157.873 209.6 152.4H209.4Z",
    fill: "#DFE1E5"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.8 58.7008V50.9008C185.814 50.7613 185.798 50.6205 185.754 50.4873C185.71 50.3542 185.639 50.2318 185.545 50.1281C185.45 50.0244 185.335 49.9416 185.207 49.8853C185.079 49.8289 184.94 49.8001 184.8 49.8008H172C171.708 49.8008 171.428 49.9167 171.222 50.123C171.016 50.3293 170.9 50.6091 170.9 50.9008V58.7008C170.9 58.966 170.794 59.2204 170.607 59.4079C170.419 59.5954 170.165 59.7008 169.9 59.7008C169.608 59.7008 169.328 59.8167 169.122 60.023C168.916 60.2293 168.8 60.5091 168.8 60.8008V62.8008H188V60.8008C188 60.5091 187.884 60.2293 187.678 60.023C187.471 59.8167 187.192 59.7008 186.9 59.7008C186.76 59.7148 186.619 59.6994 186.486 59.6554C186.353 59.6115 186.231 59.54 186.127 59.4457C186.023 59.3515 185.941 59.2364 185.884 59.1081C185.828 58.9797 185.799 58.841 185.8 58.7008Z",
    fill: "url(#paint1_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.4 75.9004H6.7998C3.4861 75.9004 0.799805 78.5867 0.799805 81.9004V139.41C0.799805 142.724 3.4861 145.41 6.7998 145.41H172.4C175.714 145.41 178.4 142.724 178.4 139.41V81.9004C178.4 78.5867 175.714 75.9004 172.4 75.9004Z",
    fill: "#0065FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.4 75.9004H151.6C145.453 78.9322 140.079 83.3283 135.889 88.7532C131.7 94.1781 128.805 100.488 127.425 107.202C126.046 113.917 126.218 120.857 127.93 127.494C129.641 134.132 132.846 140.29 137.3 145.5H172.4C173.991 145.5 175.517 144.868 176.643 143.743C177.768 142.618 178.4 141.092 178.4 139.5V81.9004C178.4 80.3091 177.768 78.783 176.643 77.6577C175.517 76.5325 173.991 75.9004 172.4 75.9004Z",
    fill: "#0052CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.383 73.8744L145.595 66.662C145.989 66.2681 146.523 66.0469 147.08 66.0469C147.637 66.0469 148.171 66.2681 148.565 66.662L152.03 70.1268L141.848 80.3091L138.383 76.8443C137.989 76.4505 137.768 75.9163 137.768 75.3594C137.768 74.8024 137.989 74.2683 138.383 73.8744Z",
    fill: "#DE350B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M211.027 66.6843L218.239 73.8968C218.633 74.2906 218.854 74.8247 218.854 75.3817C218.854 75.9386 218.633 76.4728 218.239 76.8666L214.704 80.4021L204.451 70.1491L207.986 66.6136C208.187 66.4122 208.427 66.2538 208.691 66.1479C208.954 66.042 209.237 65.9908 209.521 65.9974C209.806 66.004 210.086 66.0683 210.345 66.1863C210.603 66.3044 210.835 66.4738 211.027 66.6843Z",
    fill: "#FF7452"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M178.4 151.101C203.198 151.101 223.3 130.998 223.3 106.201C223.3 81.4032 203.198 61.3008 178.4 61.3008C153.602 61.3008 133.5 81.4032 133.5 106.201C133.5 130.998 153.602 151.101 178.4 151.101Z",
    fill: "url(#paint2_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M214.587 118.166C221.212 98.136 210.344 76.5281 190.314 69.9037C170.283 63.2793 148.676 74.147 142.051 94.1772C135.427 114.208 146.294 135.815 166.325 142.44C186.355 149.064 207.963 138.197 214.587 118.166Z",
    fill: "#DFE1E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M182.3 70.5996C176.572 69.7048 170.716 70.1219 165.173 71.8195C159.63 73.5171 154.544 76.4508 150.3 80.3996C145.202 85.8981 141.86 92.7918 140.7 100.2C139.454 108.046 140.687 116.086 144.225 123.2C147.763 130.313 153.431 136.146 160.44 139.887C167.449 143.628 175.45 145.091 183.329 144.072C191.208 143.052 198.574 139.601 204.4 134.2C209.498 128.701 212.84 121.807 214 114.4C214.799 109.442 214.612 104.375 213.451 99.4893C212.289 94.6036 210.176 89.9948 207.232 85.9266C204.287 81.8585 200.57 78.4108 196.292 75.7808C192.014 73.1508 187.259 71.3902 182.3 70.5996Z",
    fill: "url(#paint3_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5 137.801L177.7 133.801L177.5 137.801L175.3 137.601L176.1 129.701H177.7V133.701L177.5 137.801ZM187.6 136.401L185.2 128.801L186.8 128.201L189.7 135.701L187.6 136.401ZM165.6 135.001L163.5 134.001L167.3 127.001L168.8 127.701L165.6 135.001ZM198.4 130.601L193.3 124.501L194.6 123.301L200.1 129.201L198.4 130.601ZM155.5 127.901L154 126.201L160.2 121.201L161.3 122.401L155.5 127.901ZM206.2 121.201L199.2 117.401C199.474 116.921 199.708 116.419 199.9 115.901L207.2 119.101C206.908 119.82 206.574 120.521 206.2 121.201ZM149 117.501C148.69 116.818 148.423 116.117 148.2 115.401L155.9 113.101C156.021 113.615 156.189 114.117 156.4 114.601L149 117.501ZM209.8 109.401L201.9 108.601C201.9 108.001 202 107.501 202 107.001H210C209.992 107.805 209.925 108.607 209.8 109.401ZM154.9 105.501H146.9V105.301C146.9 104.601 147 103.901 147 103.101L155 103.901C154.922 104.43 154.889 104.966 154.9 105.501ZM201 99.4008C200.8 98.9008 200.7 98.4008 200.5 97.9008L207.9 95.0008L208.7 97.1008L201 99.4008ZM156.9 96.6008L149.7 93.3008C149.992 92.582 150.326 91.8808 150.7 91.2008L157.7 95.1008C157.392 95.5776 157.124 96.0794 156.9 96.6008ZM196.7 91.3008L195.6 90.1008L201.4 84.6008L202.9 86.3008L196.7 91.3008ZM162.3 89.1008L156.8 83.3008C157.315 82.7455 157.885 82.2431 158.5 81.8008L163.6 88.0008C163.123 88.3124 162.686 88.6818 162.3 89.1008ZM189.6 85.5008L188.1 84.7008L191.4 77.4008L193.4 78.4008L189.6 85.5008ZM170.1 84.2008L167.2 76.7008L169.4 76.0008L171.7 83.7008L170.1 84.2008ZM180.8 82.8008H179L179.3 78.8008V74.8008H181.6L180.8 82.8008Z",
    fill: "#344563"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.726 75.1014L177.229 106.16L179.158 106.688L187.655 75.6292L185.726 75.1014Z",
    fill: "#FF5630"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M178.3 109.6C180.012 109.6 181.4 108.212 181.4 106.5C181.4 104.788 180.012 103.4 178.3 103.4C176.588 103.4 175.2 104.788 175.2 106.5C175.2 108.212 176.588 109.6 178.3 109.6Z",
    fill: "#F4F5F7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M178.3 110.501C177.485 110.501 176.688 110.257 176.012 109.802C175.336 109.347 174.811 108.701 174.503 107.946C174.196 107.191 174.121 106.361 174.288 105.563C174.454 104.765 174.855 104.035 175.438 103.466C176.021 102.897 176.761 102.514 177.563 102.368C178.365 102.221 179.192 102.317 179.939 102.642C180.687 102.968 181.32 103.509 181.758 104.196C182.196 104.884 182.42 105.686 182.4 106.501C182.4 107.035 182.293 107.563 182.086 108.055C181.879 108.547 181.575 108.992 181.193 109.365C180.811 109.738 180.358 110.03 179.861 110.225C179.365 110.421 178.834 110.514 178.3 110.501ZM178.3 104.401C177.743 104.401 177.209 104.622 176.815 105.016C176.421 105.41 176.2 105.944 176.2 106.501C176.2 107.058 176.421 107.592 176.815 107.986C177.209 108.38 177.743 108.601 178.3 108.601C178.857 108.601 179.391 108.38 179.785 107.986C180.179 107.592 180.4 107.058 180.4 106.501C180.4 105.944 180.179 105.41 179.785 105.016C179.391 104.622 178.857 104.401 178.3 104.401Z",
    fill: "#FF5630"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 105.199H20.5996V107.199H120.7V105.199Z",
    fill: "#B2D4FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1996 122.699H20.5996V124.699H64.1996V122.699Z",
    fill: "#B2D4FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 113.801H20.5996V115.801H120.7V113.801Z",
    fill: "#B2D4FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.7 96.6992H20.5996V98.6992H120.7V96.6992Z",
    fill: "#B2D4FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 21.0996H48.2998V23.0996H163.4V21.0996Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M111.9 38.5996H48.2998V40.5996H111.9V38.5996Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8998 56.0996H48.2998V58.0996H91.8998V56.0996Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 29.5996H48.2998V31.5996H163.4V29.5996Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 12.5H48.2998V14.5H163.4V12.5Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M191.9 34.6992C198.803 34.6992 204.4 29.1028 204.4 22.1992C204.4 15.2957 198.803 9.69922 191.9 9.69922C184.996 9.69922 179.4 15.2957 179.4 22.1992C179.4 29.1028 184.996 34.6992 191.9 34.6992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 37.7297,
    y1: 35.25,
    x2: 215.36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 168.8,
    y1: 56.3408,
    x2: 187.96,
    y2: 56.3408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE350B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 210.19,
    y1: 74.4708,
    x2: 146.68,
    y2: 137.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF7452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE350B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 138.06,
    y1: 107.3,
    x2: 214.51,
    y2: 107.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 0.5H223.3V221.9H0.799805V0.5Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaries);
export default __webpack_public_path__ + "static/media/summaries.7b6ab845562e5f23caab98af2e2e8aab.svg";
export { ForwardRef as ReactComponent };